import { render, staticRenderFns } from "./ExportacaoRMS.vue?vue&type=template&id=1e1d741f"
import script from "./ExportacaoRMS.vue?vue&type=script&lang=js"
export * from "./ExportacaoRMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports